module.exports = __webpack_public_path__ + "img/certificate10.898c47f1.png";